<template>
	<!-- eslint disable -->
	<main-layout>
		<div class="container">
			<H1 class="has-text-primary is-size-3 ">DASHBOARD</H1>
			<div class="limitWidth">
				<hr/>
			</div>
			<div id="slinksTable wideLimitWidth">
				<div class="is-size-4">
					Your Subscriptions:
				</div>
				<table class="bottom10 ">
					<tr class="top10 has-text-weight-bold" >
						<td width="10%">Subcription</td>
						<td width="20%">Status</td>
						<td width="10%">Renews</td>
						<td width="10%">&nbsp;</td>
					</tr>
					<template v-for="(item, index) in subscriptionsArr" class="trBorder">
						<tr :class="{'has-background-light': ((index + 1) % 2)}">
							<td class="has-text-weight-bold"><span class="has-text-grey">&bull;</span> {{item.id}}</td>
							<td :class="{'has-text-danger': item.status == constants.INGRACEPERIOD}">{{item.status | statusString}}</td>
							<td>{{az.dateConvert(item.expDate)}}</td>
							<td class="has-text-right">
								<button class="button is-small is-warning" @click="renew(item.id)" v-if="item.status == constants.INGRACEPERIOD">RENEW</button>
								<button class="button is-small is-warning" @click="cancel(item.id)" v-if="item.status == constants.ACTIVE">REMOVE</button>
								<button class="button is-small is-warning" @click="reinstate(item.id)" v-if="item.status == constants.CANCELED">REINSTATE</button>
							</td>
						</tr>
						<tr class="slctTableRow trBorder" :class="{'has-background-light': ((index + 1) % 2)}">
							<td>&nbsp;</td>
							<td colspan="3">
								<i class="has-text-weight-bold is-size-7 contentsLabel" @click="toggleHidden(index)"><i  class="fa fa-play faSmall" v-bind:id="'tri' + index" :class="{'rotate': item.show}"></i>Contents</i><br>
								<transition name="fade2"> 
									<table  width="100%" class="is-italic is-size-7" v-bind:id="'table' + index" v-show="item.show" >  
										<tr v-for="(line, i) in item.contents" class="trHeightShort" :key="line.id" :class="{'has-background-white': ((i + 1) % 2), 'has-background-light': (i % 2)}">
											<td width="40%" >
												<span class="has-text-weight-bold">{{line.slink}}:</span> ${{line.cost}}
											</td>
											<td>
												{{line.subsQ}} Subslink Packs: ${{line.subsCost}}
											</td>
											<td class="has-text-right">
												Total: ${{line.total}}
											</td>
											<td>
												<button class="button is-small is-pulled-right slinkEditBt" @click="goToDetail(line.slink)">MANAGE</button>
											</td>
										</tr>
										<tr class="trHeightShort">
											<td><span class="tdTop" v-if="item.status == constants.INGRACEPERIOD"><br>*If you would like to change the contents of this subscription before renewing it, click on the MANAGE buttons next to each item</span><br><br></td>
											<td></td>
											<td class="has-text-right has-text-weight-bold">${{item.total}}<br><br></td>
											<td></td>
										</tr>
									</table>
								</transition>
							</td>
						</tr>
					</template>
				</table>
			</div>
		</div>
	</main-layout>
</template>

<script>
	import MainLayout from "../layouts/Main.vue";
	import constants from '../STATIC/constants.js'
	import { AZEventBus } from '../components/AZEventBus.js';
	export default {
	components: {
			MainLayout
	},
	data: function() {
		return {
			subscriptionsArr: [],
			constants, 
			az: az,
			inited: false
		};
	},
	mounted: function() {
		const self = this;
		//az.addRemSpinner(true, 'id', 'slinksTable');
		self.worked = function(data) {
		//az.addRemSpinner(false, 'class', 'cart');
			for (var i = 0; i < data.length; i++) {
				if(data[i].status == constants.INGRACEPERIOD){
					data[i].show = true;
				} else {
					data[i].show = false;
				}
			}
			data.sort(function(a, b) {
				return new Date(a.expDate) - new Date(b.expDate);
			});

			self.subscriptionsArr = data;
		};
		self.noWorked = function() {
			//az.addRemSpinner(false, 'class', 'cart');
			self.showModalOK({ message: "There was en arror loading cart contents. Please try again." });
		};

		function init(){
			self.inited = true
			self.$root.apiClient.get("subscriptions.json", {}, self.worked,	self.noWorked,"static");
		}

		if(self.$root.doneFederating){
			init();
		}

		AZEventBus.$once('onFederate', msg => {
			if(self.inited == false)
            	init();
		});
	},
	methods: {
		showDetail: function(slink) {
			this.$router.push({ name: "mngdetail", params: { slink: slink } });
		},
		toggleHidden: function(index) {
			this.subscriptionsArr[index].show = !this.subscriptionsArr[index].show;
			document.getElementById("tri" + index).classList.toggle("rotate");
		},
		goToDetail: function(slink){
			this.$router.push({name: 'mngdetail', params: {slink: slink}})
		},
		renew: function(id){
			this.$root.loadedModalComponent = 'ModalAddRemSubscr';
			this.$root.modalPropsObj = {id: id, callBack: callApi, toDo: 'renew'};
			this.$root.showModal = true;

			function callApi(){
				//TODO add renewal to cart
			}
		}, 
		cancel: function(id){
			this.$root.loadedModalComponent = 'ModalAddRemSubscr';
			this.$root.modalPropsObj = {id: id, callBack: callApi, toDo: 'cancel'};
			this.$root.showModal = true;

			function callApi(){
				//TODO implement remAddSpinner
			}
		},
		reinstate: function(id){
			this.$root.loadedModalComponent = 'ModalAddRemSubscr';
			this.$root.modalPropsObj = {id: id, callBack: callApi, toDo: 'reinstate'};
			this.$root.showModal = true;

			function callApi(){
				//TODO implement remAddSpinner
			}
		}
	}
	};
</script>

<style  scoped>
	table tr {
		height: 3rem;
	}

	.trHeightShort {
		height: 1rem;
	}

	table tr td {
		padding-left: 2px;
		padding-right: 3px;
		vertical-align: bottom;
	}

	.button {
		vertical-align: middle;
	}

	.contentsLabel {
		cursor: pointer;
		color: #999
	}

	.faSmall {
		font-size: 0.6rem;
		color: #aaa;
		position: relative;
		top: -1px;
		margin-right: 2px;
	}

	.rotate {
		transform: rotate(90deg);
		top: 0;
	}

	.slctTableRow {
		margin-top: -10px;
	}

	.slctTableRow td {
		vertical-align: middle;
		padding-left: 5px;
	}

	.redText{
		color: #F00;
	}

	.slinkEditBt{
		transform: scale(.8, .8);
		
	}

	.trBorder{
		border-bottom: 1px solid #ffdd57;
	}

	.tdTop{
		vertical-align: top;
	}

	
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue